import { QuickFilter as FuseQuickFilter, QuickFilterProps as FuseQuickFilterProps } from "@tvg/fuse/quick-filter";
import { ImageLink } from "amp-types/plp-slot";
import useGlobalConfig from "client/context/GlobalConfig";
import buildGoogleAnalyticsTag from "client/utils/getDataAnalyticsId";
import getImageLink from "client/utils/getImageLink";
import React, { useMemo } from "react";

interface QuickFilterProps extends Omit<FuseQuickFilterProps, "image"> {
  image: ImageLink;
  position: number;
}

const QuickFilter: React.FC<QuickFilterProps> = ({ image, position, ...props }) => {
  const { brand } = useGlobalConfig();

  const imageConfig = useMemo<FuseQuickFilterProps["image"]>(
    () => ({
      isLazy: true,
      imageLink: getImageLink(image, { brand, w: 320, qlt: "default" }),
    }),
    [brand, image],
  );

  const dataAnalyticsId = useMemo(
    () => buildGoogleAnalyticsTag("QuickFilterCarousel", props.label, position),
    [position, props.label],
  );

  return (
    <FuseQuickFilter
      {...props}
      dataTestId="content-quick-filter"
      image={imageConfig}
      dataAnalyticsId={dataAnalyticsId}
    />
  );
};

export default React.memo(QuickFilter);
